<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="box-offset" v-else>
            <div class="box-ttl-wrap">
                <div class="box-ttl">Add Filter</div>
            </div>
            <div class="form mt-3">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Name</label>
                            <input type="text" class="form-control" v-model="filters.name">
                        </div>
                    </div>
                    <div class="col-md-6 parent-container">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Tags</label>

                            <VueMultiSelect
                                style="width: 100%"
                                allow-empty="required"
                                multiple="multiple"
                                :options="tagOptions"
                                v-model="selectedTags"
                                @input="fillIdArray('tag')"
                            ></VueMultiSelect>

                        </div>
                    </div>
                    <div class="col-md-12">
                        <label for="" class="form-label">Rate of Pay Desired</label>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group form-group-1">
                                    <input
                                        type="number"
                                        class="form-control"
                                        placeholder="Between"
                                        v-model="filters.pay_between"
                                        @change="checkPay"
                                    >
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group form-group-1">
                                    <input
                                        type="number"
                                        class="form-control"
                                        placeholder="End"
                                        v-model="filters.pay_end"
                                        @change="checkPay"
                                    >
                                    <p
                                        class="pb-0"
                                        style="font-size: small; color: #dd3722"
                                        v-if="errorValidationPay">
                                        {{ errorMessage }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-6">
                                <label for="" class="form-label">Date Applied Between</label>
                                <div class="form-group form-group-1">
                                    <date-picker
                                        style="width: 100%;"
                                        v-model="filters.date_applied_between"
                                        value-type="format"
                                        format="YYYY-MM-DD"
                                    ></date-picker>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="" class="form-label">Date Applied End</label>
                                <div class="form-group form-group-1">
                                    <date-picker
                                        style="width: 100%;"
                                        v-model="filters.date_applied_end"
                                        value-type="format"
                                        format="YYYY-MM-DD"
                                        :disabled-date="notBefore"
                                    ></date-picker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 parent-container" v-if="languagesOptions">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Language</label>

                            <VueMultiSelect
                                allow-empty="required"
                                multiple="multiple"
                                :options="languagesOptions"
                                v-model="selectedLanguages"
                                @input="fillIdArray('language')"
                            ></VueMultiSelect>

                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Location</label>

                            <vue-google-autocomplete
                                id="map"
                                classname="form-control"
                                placeholder="Start typing"
                                v-on:placechanged="getAddressData"
                            >
                            </vue-google-autocomplete>

                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Radius</label>
                            <select class="custom-select" v-model="filters.radius">
                                <option v-for="option in radius" :value="option" :key="option">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Position</label>
                            <select
                                class="custom-select"
                                v-model="filters.position"
                                @change="handleSelectChange"
                            >
                                <option value="null" selected >Select One</option>
                                <option
                                    v-for="position in positions"
                                    :value="position.id"
                                >
                                    {{ position.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Status</label>
                            <select
                                class="custom-select"
                                v-model="filters.status"
                            >
                                <option value="all" >All</option>
                                <option value="active" >Active</option>
                                <option value="inactive" >Inactive</option>
                                <option value="pending" >In process</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Stages:</label>
                            <select
                                class="custom-select"
                                v-model="filters.stage"
                            >
                                <option value="all">Select One</option>
                                <option
                                    v-for="stage in listOfStages"
                                    :key="stage.id"
                                    :value="stage.id"
                                >{{stage.name}} - {{setStatus(stage.status)}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="table-holder table-responsive ">
                            <table class="table shifts-table">
                                <thead>
                                <tr>
                                    <th>Shift/Days</th>
                                    <th >Mon</th>
                                    <th>Tue</th>
                                    <th>Wed</th>
                                    <th>Thu</th>
                                    <th>Fri</th>
                                    <th>Sat</th>
                                    <th>Sun</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Morning</td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input
                                                    class="form-check-input-checkbox"
                                                    type="checkbox"
                                                    name="morning"
                                                    value="monday"
                                                    id="mon-mor"
                                                    v-model="filters.shifts.morning">
                                                <label class="form-check-label" for="mon-mor"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       name="morning"
                                                       value="tuesday"
                                                       id="tue-mor"
                                                       v-model="filters.shifts.morning">
                                                <label class="form-check-label" for="tue-mor"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       name="morning"
                                                       value="wednesday"
                                                       id="wed-mor"
                                                       v-model="filters.shifts.morning">
                                                <label class="form-check-label" for="wed-mor"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="thursday"
                                                       name="morning"
                                                       id="thu-mor"
                                                       v-model="filters.shifts.morning">
                                                <label class="form-check-label" for="thu-mor"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="friday"
                                                       name="morning"
                                                       id="fri-mor"
                                                       v-model="filters.shifts.morning">
                                                <label class="form-check-label" for="fri-mor"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="saturday"
                                                       name="morning"
                                                       id="sat-mor"
                                                       v-model="filters.shifts.morning">
                                                <label class="form-check-label" for="sat-mor"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="sunday"
                                                       name="morning"
                                                       id="sun-mor"
                                                       v-model="filters.shifts.morning">
                                                <label class="form-check-label" for="sun-mor"></label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Afternoon</td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="monday"
                                                       name="afternoon"
                                                       id="aft-mon"
                                                       v-model="filters.shifts.afternoon">
                                                <label class="form-check-label" for="aft-mon"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="tuesday"
                                                       name="afternoon"
                                                       id="aft-tue"
                                                       v-model="filters.shifts.afternoon">
                                                <label class="form-check-label" for="aft-tue"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="wednesday"
                                                       name="afternoon"
                                                       id="aft-wed"
                                                       v-model="filters.shifts.afternoon">
                                                <label class="form-check-label" for="aft-wed"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="thursday"
                                                       name="afternoon"
                                                       id="aft-thu"
                                                       v-model="filters.shifts.afternoon">
                                                <label class="form-check-label" for="aft-thu"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="friday"
                                                       name="afternoon"
                                                       id="aft-fri"
                                                       v-model="filters.shifts.afternoon">
                                                <label class="form-check-label" for="aft-fri"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="saturday"
                                                       name="afternoon"
                                                       id="aft-sat"
                                                       v-model="filters.shifts.afternoon">
                                                <label class="form-check-label" for="aft-sat"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="sunday"
                                                       name="afternoon"
                                                       id="aft-sun"
                                                       v-model="filters.shifts.afternoon">
                                                <label class="form-check-label" for="aft-sun"></label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Night</td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="monday"
                                                       name="night"
                                                       id="night-mon"
                                                       v-model="filters.shifts.night">
                                                <label class="form-check-label" for="night-mon"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="tuesday"
                                                       name="night"
                                                       id="night-tue"
                                                       v-model="filters.shifts.night">
                                                <label class="form-check-label" for="night-tue"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="wednesday"
                                                       name="night"
                                                       id="night-wed"
                                                       v-model="filters.shifts.night">
                                                <label class="form-check-label" for="night-wed"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="thursday"
                                                       name="night"
                                                       id="night-thu"
                                                       v-model="filters.shifts.night">
                                                <label class="form-check-label" for="night-thu"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="friday"
                                                       name="night"
                                                       id="night-fri"
                                                       v-model="filters.shifts.night">
                                                <label class="form-check-label" for="night-fri"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="saturday"
                                                       name="night"
                                                       id="night-sat"
                                                       v-model="filters.shifts.night">
                                                <label class="form-check-label" for="night-sat"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group form-group-1">
                                            <div class="form-check">
                                                <input class="form-check-input-checkbox" type="checkbox"
                                                       value="sunday"
                                                       name="night"
                                                       id="night-sun"
                                                       v-model="filters.shifts.night">
                                                <label class="form-check-label" for="night-sun"></label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="btns-wrap">
                            <button  class="btn btn--outline-primary w-100 w-sm-auto color--gray" @click="resetFilters" >Reset</button>
                            <button  class="btn btn--secondary w-100 w-sm-auto" @click.prevent="searchAdvanced">Search</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import VueMultiSelect from "../../../../../resources/js/plugins/VueMultiSelect.vue";
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import ResponsesServices from "../../../PreconfiguredResponses/resources/js/services/ResponsesServices";
import StatusService from "../../../Status/resources/js/services/StatusService";

export default {
    name: 'AdvancedSearch',
    components: {VueMultiSelect, VueGoogleAutocomplete },
    emits: ['search', 'reset',],
    data() {
        return {
            loading: true,
            positions: [],
            selectedLanguages:[],
            selectedTags:[],
            tagsList: [],
            listOfStages: null,
            tagOptions: [],
            languagesList:[],
            languagesOptions: [],
            limitsList: [ 10, 25, 50, 100],
            errorMessage:'The second number must exceed the first one',
            errorValidationDate: false,
            errorValidationPay: false,
            filters: {
                date_applied_between: null,
                date_applied_end: null,
                languages: [],
                stage: null,
                name: '',
                latitude: null,
                longitude:null,
                pay_between: null,
                pay_end: null,
                position: null,
                radius: 0,
                shifts: {
                    morning: [],
                    afternoon: [],
                    night: [],
                },
                status: 'all',
                sortBy: null,
                sortDir: 'asc',
                tags: [],
            }
        }
    },
    computed: {
        radius() {
            const startValue = 0;
            const endValue = 50;
            const step = 5;
            const optionsArray = [];

            for (let i = startValue; i <= endValue; i += step) {
                optionsArray.push(i);
            }
            return optionsArray;
        },
    },
    methods: {
        setStatus(status) {
            if (status === 'active') {
                return "Active"
            } else {
                return 'In process'
            }
        },
        async getListOfStages() {
            try {
                const {data : response } = await StatusService.getListOfStatuses()
                this.listOfStages = response
            } catch (e) {
                this.$showErrorMessage('Filter by status does not work\n' +
                    'Try again')
            }
        },
        checkPay() {
            this.errorValidationPay = Number(this.filters.pay_between) > Number(this.filters.pay_end)
        },
        notBefore(date) {
            return date < new Date(this.filters.date_applied_between);
        },
        getAddressData(place) {
            let { longitude, latitude } = place
            this.filters.longitude = longitude
            this.filters.latitude = latitude
        },
        async getListOfPositions() {
            try {
                const {data: positions} = await CommonService.getListOfPositions()
                this.positions = positions
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        async getListOfLanguages() {
            try {
                const {data: languages} = await CommonService.getListOfLanguages()
                this.languagesList = languages
                this.languagesOptions = this.languagesList.map(language => (language.name));
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        async getListOfTags() {
            try {
                const {data: tags} = await CommonService.getListOfTags()
                this.tagsList = tags
                this.tagOptions= this.tagsList.map(tag => (tag.name));

            } catch (error) {
                this.$handleErrors(error);
            }
        },
        handleSelectChange() {
            if (this.filters.position === "null") {
                this.filters.position = null;
            }
        },
        resetFilters() {
            this.selectedTags = []
            this.selectedLanguages = []
            const emptyFilters = {
                date_applied_between: null,
                date_applied_end: null,
                languages: [],
                tags: [],
                limit: 10,
                name: '',
                latitude: null,
                longitude:null,
                pay_between: null,
                pay_end: null,
                page: 1,
                perPage: 10,
                position: null,
                radius: 0,
                shifts: {
                    morning: [],
                    afternoon: [],
                    night: [],
                },
                sortBy: null,
                sortDir: 'asc',
            }
            this.$emit('reset', emptyFilters )
            this.filters = emptyFilters
        },
        searchAdvanced() {
            if (this.errorValidationDate === false && this.errorValidationPay === false) {
                this.$emit('search', this.filters)
            } else {
                this.$showValidationErrorMessage('Search error', 'Please enter correct parameters')
            }
        },
        fillIdArray(field) {
            if (field === 'language') {
                this.filters.languages = []
                this.selectedLanguages.forEach(selectedLang => {
                    const foundLanguage = this.languagesList.find(lang => lang.name === selectedLang);
                    if (foundLanguage) {
                        this.filters.languages.push(foundLanguage.id);
                    }
                });
            } else if (field === 'tag') {
                this.filters.tags = []
                this.selectedTags.forEach(selectedTag => {
                    const foundTag = this.tagsList.find(tag => tag.name === selectedTag);
                    if (foundTag) {
                        this.filters.tags.push(foundTag.id);
                    }
                });
            }
        },
        async loadData() {
            this.loading = true;

            try {
                await Promise.all([
                    this.getListOfStages(),
                    this.getListOfPositions(),
                    this.getListOfTags(),
                    this.getListOfLanguages()
                ]);
            } catch (e) {
                console.error("Error loading data");
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.loadData()
    }

}

</script>

<style>

input.select2-search__field{
    width: 100% !important;
}

</style>
